<template>
  <div class="container">
    <button class="button is-primary is-small is-pulled-right" @click="add">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Cadastrar</span>
    </button>
    <br><br>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraBPVersaoConfig && !mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição do balanço patrimonial" v-model="balancoPatrimonialVersao.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nome da Fórmula do Ativo</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe o nome da fórmula do ativo" v-model="balancoPatrimonialVersao.nome_formula_ativo">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nome da Fórmula do Passivo</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe o nome da fórmula do passivo" v-model="balancoPatrimonialVersao.nome_formula_passivo">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Comentários</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Comente sobre esse balanço patrimonial" v-model="balancoPatrimonialVersao.comentario"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Versão</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="balancoPatrimonialCompartilhar.versao_plano_contas">
                        <option v-for="versao_plano_contas in versoesPlanosContas" :key="versao_plano_contas.id" :value="versao_plano_contas">
                          {{ versao_plano_contas.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraBPVersaoConfig">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Destino</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="balancoPatrimonialVersaoConfig.destino">
                      <option value="A">Ativo</option>
                      <option value="P">Passivo</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição da versão do plano de contas" v-model="balancoPatrimonialVersaoConfig.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Sequencial</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" v-model="balancoPatrimonialVersaoConfig.sequencial">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Negrito</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="balancoPatrimonialVersaoConfig.eNegrito">
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Desejada</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="balancoPatrimonialVersaoConfig.tipo_evolucao_desejada">
                      <option value="A">Alta</option>
                      <option value="B">Baixa</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Referência AV</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="balancoPatrimonialVersaoConfig.referencia_av">
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Análise Dinâmica</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="balancoPatrimonialVersaoConfig.tipo_grupo_analise_dinamica">
                      <option value="NE">Nenhum</option>
                      <option value="CF">Circulante Financeiro</option>
                      <option value="CO">Circulante Operacional</option>
                      <option value="NC">Não Circulante</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Fórmula</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Informe a fórmula para preenchimento" v-model="balancoPatrimonialVersaoConfig.formula"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button"  v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns">
      <div class="column is-5">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Balanços Patrimoniais</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bp, index) in balancosPatrimoniais" :key="bp.id">
                    <td>{{ bp.descricao }}</td>
                    <!-- <td>{{ bp.comentario }}</td> -->
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" :disabled="mostraCompartilhamento || mostraBPVersaoConfig" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" :disabled="mostraCompartilhamento || mostraBPVersaoConfig" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash"></i>
                          </span>
                        </button>
                        <button class="button is-small is-primary is-outlined" @click="callCompartilhamento(bp)" :disabled="mostraCompartilhamento || mostraBPVersaoConfig" title="Selecionar">
                          <span class="icon is-small">
                            <i class="fas fa-share-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="callBPConfig(bp)" :disabled="mostraCompartilhamento || mostraBPVersaoConfig" title="Configurar">
                          <span class="icon is-small">
                            <i class="fas fa-th-list"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraCompartilhamento">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Compartilhar {{ bpVersaoSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraCompartilhamento = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Versão</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bpVersao, index) in balancoPatrimonialVersoes" :key="bpVersao.id">
                    <td>{{ bpVersao.versao_plano_contas.descricao }}</td>
                    <td class="has-text-centered">
                      <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                        <span class="icon is-small">
                          <i class="fas fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraCompartilhamento = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraBPVersaoConfig">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Linhas do Balanço Patrimonial {{ bpVersaoSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraBPVersaoConfig = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Sequencial</th>
                    <th>Quadro</th>
                    <th>Descrição</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(linha, index) in linhasBalancoPatrimonial" :key="linha.id">
                    <td>{{ linha.sequencial }}</td>
                    <td>{{ linha.destino === 'A' ? 'ATIVO' : 'PASSIVO' }}</td>
                    <td>{{ linha.descricao }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="abrirFormulas(linha)" title="Fórmula do perfil">
                          <span class="icon is-small">
                            <i class="fas fa-calculator"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraBPVersaoConfig = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
    
    <bp-formula-perfil v-if="linhaSelecionada" :key="linhaSelecionada.id" :visivel="mostrarFormulas" :linha="linhaSelecionada" @fechar="fecharFormulas"/>

  </div>
</template>

<script>
    import {http} from '../../services/config'
    import BpFormulaPerfil from './BalancoPatrimonialFormulaPerfil.vue'

    export default {
        name: "BalancoPatrimonialVersao",

        components: { BpFormulaPerfil },        

        data(){
            return{
                balancoPatrimonialVersao: {
                    id: null,
                    descricao: null,
                    comentario: null,
                    versaoPlanoContas: null,
                    nome_formula_ativo: null,
                    nome_formula_passivo: null
                },
                balancoPatrimonialCompartilhar: { id: null,
                    balanco_patrimonial_versao: null,
                    versao_plano_contas: null
                },
                balancoPatrimonialVersaoConfig: {
                    id: null,
                    sequencial: null,
                    descricao: null,
                    eNegrito: "N",
                    indentacao: 0,
                    destino: "A",
                    formula: null,
                    tipo_evolucao_desejada: "A",
                    referencia_av: "N",
                    tipo_grupo_analise_dinamica: "NE"
                },
                versoesPlanoContas: [],
                balancosPatrimoniais: [],
                linhasBalancoPatrimonial: [],
                balancoPatrimonialVersoes: [],
                isShowModal: false,
                mostraBPVersaoConfig: false, 
                mostraCompartilhamento: false,
                bpVersaoSelecionado: {
                    id: null,
                    descricao: null
                },
                previous: null,
                next: null,
                page: null,
                numpages: null,
                mostrarFormulas: false,
                linhaSelecionada: null,
            }
        },

        methods: {

            abrirFormulas(linha) {
              this.linhaSelecionada = linha;
              this.mostrarFormulas = true;
            },       
            
            fecharFormulas() {
              this.mostrarFormulas = false;
              this.linhaSelecionada = null;
            },            

            add: function() {
                this.clearFields()
                this.isShowModal = true              
            },

            edit: function(index){
                if (!this.mostraBPVersaoConfig && !this.mostraCompartilhamento) {
                    this.balancoPatrimonialVersao.id = this.balancosPatrimoniais[index].id
                    this.balancoPatrimonialVersao.descricao = this.balancosPatrimoniais[index].descricao
                    this.balancoPatrimonialVersao.nome_formula_ativo = this.balancosPatrimoniais[index].nome_formula_ativo
                    this.balancoPatrimonialVersao.nome_formula_passivo = this.balancosPatrimoniais[index].nome_formula_passivo
                    this.balancoPatrimonialVersao.comentario = this.balancosPatrimoniais[index].comentario
                    this.balancoPatrimonialVersao.index = index
                }
                else {
                    this.balancoPatrimonialVersaoConfig.id = this.linhasBalancoPatrimonial[index].id
                    this.balancoPatrimonialVersaoConfig.descricao = this.linhasBalancoPatrimonial[index].descricao
                    this.balancoPatrimonialVersaoConfig.sequencial = this.linhasBalancoPatrimonial[index].sequencial

                    if (this.linhasBalancoPatrimonial[index].e_negrito) {
                        this.balancoPatrimonialVersaoConfig.eNegrito = "S"
                    } else {
                        this.balancoPatrimonialVersaoConfig.eNegrito = "N"
                    }

                    this.balancoPatrimonialVersaoConfig.indentacao = this.linhasBalancoPatrimonial[index].indentacao
                    this.balancoPatrimonialVersaoConfig.formula = this.linhasBalancoPatrimonial[index].formula
                    this.balancoPatrimonialVersaoConfig.balancoPatrimonialVersao = this.bpVersaoSelecionado
                    this.balancoPatrimonialVersaoConfig.destino = this.linhasBalancoPatrimonial[index].destino
                    this.balancoPatrimonialVersaoConfig.tipo_evolucao_desejada = this.linhasBalancoPatrimonial[index].tipo_evolucao_desejada
                    this.balancoPatrimonialVersaoConfig.referencia_av = this.linhasBalancoPatrimonial[index].referencia_av
                    this.balancoPatrimonialVersaoConfig.tipo_grupo_analise_dinamica = this.linhasBalancoPatrimonial[index].tipo_grupo_analise_dinamica
                    this.balancoPatrimonialVersaoConfig.index = index
                }
                this.isShowModal = true
            },

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    if (!this.mostraBPVersaoConfig && !this.mostraCompartilhamento) {
                        http.delete('/balancoPatrimonialVersao/excluir/'+this.balancosPatrimoniais[index].id).then(response =>{
                            this.balancosPatrimoniais.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    } else if (this.mostraCompartilhamento) {
                        http.delete('/balancoPatrimonialVersao/excluirVersoes/'+this.balancoPatrimonialVersoes[index].id).then(response =>{
                            this.balancoPatrimonialVersoes.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                    else {
                        http.delete('/balancoPatrimonialVersaoConfig/excluir/'+this.linhasBalancoPatrimonial[index].id).then(response =>{
                            this.linhasBalancoPatrimonial.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                }
            },

            callCompartilhamento: function(bpVersao) {
                this.mostraCompartilhamento = true
                this.bpVersaoSelecionado = bpVersao
                http.get('balancoPatrimonialVersao/listarVersoes/', {params: {
                    idBalancoPatrimonialVersao: this.bpVersaoSelecionado.id
                }}).then(response => {
                    this.balancoPatrimonialVersoes = response.data.results
                })
            },

            clearFields: function() {
                if (!this.mostraBPVersaoConfig && !this.mostraCompartilhamento) {
                    this.balancoPatrimonialVersao = { id: null,
                    descricao: null,
                    comentario: null,
                    nome_formula_ativo: null,
                    nome_formula_passivo: null,
                    index: null }
                } else if (this.mostraCompartilhamento) {
                    this.balancoPatrimonialCompartilhar = {id: null,
                        balanco_patrimonial_versao: null,
                        versao_plano_contas: null }
                } else {
                    this.balancoPatrimonialVersaoConfig = {
                        id: null,
                        sequencial: null,
                        descricao: null,
                        eNegrito: "N",
                        indentacao: 0,
                        formula: null,
                        balancoPatrimonialVersao: this.bpVersaoSelecionado,
                        destino: "A",
                        tipo_evolucao_desejada: "A",
                        referencia_av: "N",
                        tipo_grupo_analise_dinamica: "NE",
                        index: null
                    }
                }
            },

            callBPConfig: function(bpVersao) {
                this.mostraBPVersaoConfig = true
                this.bpVersaoSelecionado = bpVersao
                http.get('balancoPatrimonialVersaoConfig/listar/', {params: {
                    idBalancoPatrimonialVersao: this.bpVersaoSelecionado.id
                }}).then(response => {
                    this.linhasBalancoPatrimonial = response.data.results
                })

            },

            save: function(){
                var data

                if (!this.mostraBPVersaoConfig && !this.mostraCompartilhamento) {

                    if (this.balancoPatrimonialVersao.descricao == null) {
                        alert('Descrição do balanço patrimonial não preenchida!')
                        return
                    }

                    if (this.balancoPatrimonialVersao.nome_formula_ativo == null || this.balancoPatrimonialVersao.nome_formula_ativo == "") {
                        alert('Nome da fórmula do ativo não preenchida!')
                        return
                    }

                    if (this.balancoPatrimonialVersao.nome_formula_passivo == null || this.balancoPatrimonialVersao.nome_formula_passivo == '') {
                        alert('Nome da fórmula do passivo não preenchida!')
                        return
                    }
                    data = {id: this.balancoPatrimonialVersao.id,
                        usuario: this.$store.state.idUser,
                        descricao: this.balancoPatrimonialVersao.descricao,
                        comentario: this.balancoPatrimonialVersao.comentario,
                        nome_formula_ativo: this.balancoPatrimonialVersao.nome_formula_ativo,
                        nome_formula_passivo: this.balancoPatrimonialVersao.nome_formula_passivo
                    }

                    let formData = new FormData()

                    formData.append('id', data.id)
                    formData.append('usuario', data.usuario)
                    formData.append('descricao', data.descricao)
                    formData.append('nome_formula_ativo', data.nome_formula_ativo)
                    formData.append('nome_formula_passivo', data.nome_formula_passivo)
                    formData.append('comentario', data.comentario)

                    if (this.balancoPatrimonialVersao.id == null) {
                        http.post('/balancoPatrimonialVersao/adicionar', formData).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.balancoPatrimonialVersao.id = response.data.id
                                this.balancosPatrimoniais.push(this.balancoPatrimonialVersao)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })

                    } else {
                        http.put('/balancoPatrimonialVersao/editar/'+this.balancoPatrimonialVersao.id, formData).then(response =>{
                            this.balancosPatrimoniais[this.balancoPatrimonialVersao.index].nome_formula_ativo = this.balancoPatrimonialVersao.nome_formula_ativo
                            this.balancosPatrimoniais[this.balancoPatrimonialVersao.index].nome_formula_passivo = this.balancoPatrimonialVersao.nome_formula_passivo
                            this.balancosPatrimoniais[this.balancoPatrimonialVersao.index].descricao = response.data.descricao
                            this.balancosPatrimoniais[this.balancoPatrimonialVersao.index].comentario = this.balancoPatrimonialVersao.comentario
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }

                } else if (this.mostraCompartilhamento) {
                    if (this.balancoPatrimonialCompartilhar.versao_plano_contas == null) {
                        alert('Versão não informada!')
                        return
                    }

                    data = {id: this.balancoPatrimonialCompartilhar.id,
                        balanco_patrimonial_versao: this.bpVersaoSelecionado.id,
                        versao_plano_contas: this.balancoPatrimonialCompartilhar.versao_plano_contas.id
                    }

                    if (this.balancoPatrimonialCompartilhar.id == null) {
                        http.post('/balancoPatrimonialVersao/adicionarVersoes', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.balancoPatrimonialCompartilhar.id = response.data.id
                                this.balancoPatrimonialVersoes.push(this.balancoPatrimonialCompartilhar)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                } else {
                    if (this.balancoPatrimonialVersaoConfig.descricao == null) {
                        alert('Descrição da linha não informada!')
                        return
                    }

                    if (this.balancoPatrimonialVersaoConfig.sequencial == null) {
                        alert('Sequencial da linha não informado!')
                        return
                    }

                    if (this.balancoPatrimonialVersaoConfig.formula == null) {
                        alert('Fórmula da linha não informada!')
                        return
                    }

                    data = {id: this.balancoPatrimonialVersaoConfig.id,
                        descricao: this.balancoPatrimonialVersaoConfig.descricao,
                        sequencial: this.balancoPatrimonialVersaoConfig.sequencial,
                        e_negrito: false,
                        indentacao: this.balancoPatrimonialVersaoConfig.indentacao,
                        formula: this.balancoPatrimonialVersaoConfig.formula,
                        destino: this.balancoPatrimonialVersaoConfig.destino,
                        tipo_evolucao_desejada: this.balancoPatrimonialVersaoConfig.tipo_evolucao_desejada,
                        referencia_av: this.balancoPatrimonialVersaoConfig.referencia_av,
                        balanco_patrimonial_versao: this.bpVersaoSelecionado.id,
                        tipo_grupo_analise_dinamica: this.balancoPatrimonialVersaoConfig.tipo_grupo_analise_dinamica
                    }

                    if (this.balancoPatrimonialVersaoConfig.eNegrito == 'S') (
                        data.e_negrito = true
                    )

                    if (this.balancoPatrimonialVersaoConfig.id == null) {
                        http.post('/balancoPatrimonialVersaoConfig/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.balancoPatrimonialVersaoConfig.id = response.data.id
                                this.linhasBalancoPatrimonial.push(this.balancoPatrimonialVersaoConfig)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                    else {
                        http.put('/balancoPatrimonialVersaoConfig/editar/'+this.balancoPatrimonialVersaoConfig.id, data).then(response =>{
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].descricao = response.data.descricao
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].sequencial = response.data.sequencial
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].e_negrito = response.data.e_negrito
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].indentacao = response.data.indentacao
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].formula = response.data.formula
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].destino = response.data.destino
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].tipo_evolucao_desejada = response.data.tipo_evolucao_desejada
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].referencia_av = response.data.referencia_av
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].tipo_grupo_analise_dinamica = response.data.tipo_grupo_analise_dinamica
                            this.linhasBalancoPatrimonial[this.balancoPatrimonialVersaoConfig.index].balanco_patrimonial_versao = this.bpVersaoSelecionado
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }                    
                }

            },
        },

        mounted: function() {
        },
        
        created: function() {
            http.get('versoesPlanoContas/listar').then(response =>{
                    this.versoesPlanosContas = response.data.results
            })

            http.get('balancoPatrimonialVersao/listar/').then(response => {
                    this.balancosPatrimoniais = response.data.results
                    this.previous = response.data.previous
                    this.next = response.data.next
                    this.page = response.data.page
                    this.numpages = response.data.numpages
            })

        }

    }
</script>


<style scoped>
</style>